import styled from "@mui/material/styles/styled";
import ToggleButtonGroup, {
  ToggleButtonGroupProps,
} from "@mui/material/ToggleButtonGroup";

type ViewToggleGroupProps = ToggleButtonGroupProps & { spacing?: string };

const ViewToggle = styled(({ spacing: _, ...props }: ViewToggleGroupProps) => (
  <ToggleButtonGroup {...props} exclusive />
))(({ spacing = "4px", theme }) => ({
  "& .MuiButtonBase-root": {
    borderRadius: "4px !important",
    padding: "2px 6px",
    border: "none",
    whiteSpace: "nowrap",
    "&:not(:last-of-type)": {
      marginRight: spacing,
    },
    fontSize: "0.875rem",
    backgroundColor: "#00000005",
    color: theme.palette.shades.neutral[400],
    "&:hover": {
      backgroundColor: theme.palette.shades.ghost[500],
      color: theme.palette.shades.primary[500],
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.shades.primary[500],
      color: "#FFF",
      "&:hover": {
        backgroundColor: theme.palette.shades.primary[600],
      },
    },
  },
}));

export default ViewToggle;
